import React from 'react';
import PropTypes from 'prop-types';
import FormField from '../elements/FormField';
import NavButton from '../../elements/NavButton';
import { formSchemaPropType } from '../../../formSchema';

export default class UserData extends React.Component {
  render() {
    const {
      formSchema,
      formData,
      nextStep,
      handleUserInput,
      nextStepHandler,
      closeHandler,
      fieldValidations,
      selectedDataQuery,
      dataQueryHeadline,
    } = this.props;
    const {
      AdventCount: {
        translations: {
          common: {
            send,
            close,
          },
          shortcode: {
            enterData,
          },
        },
      },
    } = window;
    return (
      <div className="adventcount-modal">
        <p className="adventcount-content">{dataQueryHeadline}</p>
        <div className="modal-form">
          {formSchema && Object.keys(formSchema).map((field, index) => (
            <FormField
              key={`field-${index + 1}`}
              fieldData={formSchema[field]}
              fieldInput={formData[formSchema[field].name]}
              userInputHandler={handleUserInput}
              isValid={fieldValidations[formSchema[field].name].valid}
              validationMessage={fieldValidations[formSchema[field].name].message}
              selectedDataQuery={selectedDataQuery}
            />
          ))}
        </div>
        <div className="adventcount-button-row">
          <NavButton
            toStep=""
            btnLabel={close}
            direction="close"
            clickHandler={closeHandler}
          />
          <NavButton
            toStep={nextStep}
            btnLabel={send}
            direction="next"
            clickHandler={nextStepHandler}
          />
        </div>
      </div>
    );
  }
}

UserData.propTypes = {
  formSchema: PropTypes.objectOf(formSchemaPropType).isRequired,
  formData: PropTypes.shape().isRequired,
  nextStep: PropTypes.string.isRequired,
  nextStepHandler: PropTypes.func.isRequired,
  closeHandler: PropTypes.func.isRequired,
  handleUserInput: PropTypes.func.isRequired,
  fieldValidations: PropTypes.shape().isRequired,
  dataQueryHeadline: PropTypes.string.isRequired,
};
